import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Loading from "../components/Loading";
import { Link } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { CSVLink } from "react-csv";

const mySwal = withReactContent(Swal);

class Giveaway extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			data: [],
			washerStamp: 0,
			dryerStamp: 0
		};
	}

	componentDidMount() {
		if (!this.props.admin) this.props.history.push("/admin/dashboard");
		else {
			axios
				.post("/api/admin/setting/user/reward", { operatorId: this.props.admin.operatorId }, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
				.then(res => {
					this.setState({
						...this.state,
						data: res.data,
						loading: false
					});
				})
				.catch(err => mySwal.fire("Error", err.response.data.error, "error"));
		}
	}

	handleToggle = () => this.setState({ ...this.state, toggled: !this.state.toggled });

	handleAction = id => {
		console.log({ id });
		mySwal
			.fire({
				title: "Reward Giveaway",
				text: "Which type of reward you want to give to customer?",
				icon: "question",
				showCancelButton: true,
				showDenyButton: true,
				confirmButtonText: "Voucher",
				cancelButtonText: "Stamp",
				denyButtonText: "e-Token",
				cancelButtonColor: "lime",
				denyButtonColor: "gold"
			})
			.then(clicked => {
				console.log(clicked);
				if (clicked.isConfirmed) {
					console.log("Give voucher");
					mySwal
						.fire({
							title: "Voucher",
							html: `
							<div class="text-left mt-4">
								<div class="form-group">
									<label for="title">Title</label>
									<input type="text" id="title" name="title" value="" class="form-control" required />
								</div>

								<div class="form-group">
									<label for="description">Description</label>
									<input type="text" id="description" name="description" value="" class="form-control" required />
								</div>

								<p class="mt-5 p-0 mb-0">For machine uses (required)</p>
								<div class="d-flex justify-content-around mt-3 mb-2">
									<div class="form-group">
										<label>
											<input type="checkbox" id="washerUse" name="washerUse" />
											<span>Washer User</span>
										</label>
									</div>

									<div class="form-group">
										<label>
											<input type="checkbox" id="dryerUse" name="dryerUse" />
											<span>Dryer User</span>
										</label>
									</div>
								</div>

								<div class="form-group">
									<label for="duration">Voucher lifespan (days)</label>
									<input type="text" id="duration" name="duration" value="" class="form-control" placeholder="leave blank if no expiry date" />
								</div>

								<div class="form-group">
									<label for="type">Discount Type</label>
									<select id="type" name="type" class="browser-default form-select" required>
										<option value="flat" selected>Flat (RM)</option>
										<option value="rate">Rate (%)</option>
									</select>
								</div>

								<div class="form-group">
									<label for="amount">Voucher Amount</label>
									<input type="number" id="amount" name="amount" class="form-control" value="0" min="0" max="100" required />
								</div>
							</div>
						`,
							showCancelButton: true,
							allowOutsideClick: () => !mySwal.isLoading(),
							preConfirm: () => {
								// call axios
								const title = document.querySelector("#title").value;
								const description = document.querySelector("#description").value;
								const duration = document.querySelector("#duration").value;
								const type = document.querySelector("#type").value;
								const amount = document.querySelector("#amount").value;
								const washerUse = document.querySelector("#washerUse").checked;
								const dryerUse = document.querySelector("#dryerUse").checked;

								if (!title || !description || !amount || amount === "0") {
									mySwal.fire("Missing Field", "Please fill in all the required field. (Title, description, and amount must be more than 0)", "info");
								} else if (!washerUse && !dryerUse) {
									mySwal.fire("Checkbox required", "Must select voucher can be used for washer or dryer", "info");
								} else {
									const sendThis = {
										id,
										operatorId: this.props.admin.operatorId,
										rewardType: "voucher",
										title,
										description,
										duration,
										type,
										amount,
										washerUse,
										dryerUse
									};
									console.log(sendThis);
									return axios
										.post("/api/admin/setting/giveaway", sendThis, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
										.then(res => res.data)
										.catch(err => mySwal.fire("Error", err.response.data.error, "error"));
								}
							}
						})
						.then(result => {
							console.log(result);
							if (result.value && result.value.data === "success") {
								this.setState({
									...this.state,
									loading: true
								});
								axios
									.post("/api/admin/setting/user/reward", { operatorId: this.props.admin.operatorId }, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
									.then(res => {
										this.setState({
											...this.state,
											data: res.data,
											loading: false
										});
									})
									.catch(err => mySwal.fire("Error", err.response.data.error, "error"));
							}
						});
				} else if (clicked.isDenied) {
					console.log("Give Token");
					mySwal
						.fire({
							title: "E-TOKEN",
							text: "How many e-token?",
							icon: "question",
							input: "number",
							inputLabel: "Number of e-Token",
							inputValue: 0,
							showCancelButton: true,
							inputValidator: val => {
								if (!val || val === "0") {
									return "This field is required and value must be more than 0";
								}
							},
							showLoaderOnConfirm: true,
							allowOutsideClick: () => !mySwal.isLoading(),
							preConfirm: token => {
								// call axios
								const sendThis = {
									id,
									rewardType: "token",
									token,
									operatorId: this.props.admin.operatorId
								};
								return axios
									.post("/api/admin/setting/giveaway", sendThis, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
									.then(res => res.data)
									.catch(err => mySwal.fire("Error", err.response.data.error, "error"));
								// return token;
							}
						})
						.then(result => {
							console.log(result);
							if (result.value && result.value.data === "success") {
								this.setState({
									...this.state,
									loading: true
								});
								axios
									.post("/api/admin/setting/user/reward", { operatorId: this.props.admin.operatorId }, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
									.then(res => {
										this.setState({
											...this.state,
											data: res.data,
											loading: false
										});
									})
									.catch(err => mySwal.fire("Error", err.response.data.error, "error"));
							}
						});
				} else if (clicked.isDismissed && clicked.dismiss === "cancel") {
					console.log("Give Stamp");
					mySwal
						.fire({
							title: "STAMP",
							html: `
							<div class="text-left mt-4">
								<div class="form-group">
									<label for="washerStamp">Washer Stamp</label>
									<input type="number" id="washerStamp" name="washerStamp" value="0" class="form-control" min="0" max="10" />
								</div>

								<div class="form-group">
									<label for="dryerStamp">Dryer Stamp</label>
									<input type="number" id="dryerStamp" name="dryerStamp" value="0" class="form-control" min="0" max="10" />
								</div>
							</div>
						`,
							showCancelButton: true,
							showLoaderOnConfirm: true,
							allowOutsideClick: () => !mySwal.isLoading(),
							preConfirm: () => {
								// call axios
								const washerStamp = document.querySelector("#washerStamp").value;
								const dryerStamp = document.querySelector("#dryerStamp").value;

								if (!parseInt(washerStamp) && !parseInt(dryerStamp)) {
									mySwal.fire("Error", "Please fill in at least one of the required field", "error");
								} else {
									const sendThis = {
										id,
										operatorId: this.props.admin.operatorId,
										washerStamp,
										dryerStamp,
										rewardType: "stamp"
									};
									return axios
										.post("/api/admin/setting/giveaway", sendThis, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
										.then(res => res.data)
										.catch(err => mySwal.fire("Error", err.response.data.error, "error"));
								}
								// console.log({ washerStamp, dryerStamp });
							}
						})
						.then(result => {
							console.log(result);
							if (result.value && result.value.data === "success") {
								this.setState({
									...this.state,
									loading: true
								});
								axios
									.post("/api/admin/setting/user/reward", { operatorId: this.props.admin.operatorId }, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
									.then(res => {
										this.setState({
											...this.state,
											data: res.data,
											loading: false
										});
									})
									.catch(err => mySwal.fire("Error", err.response.data.error, "error"));
							}
						});
				} else {
					console.log("cancel");
				}
			});
	};

	render() {
		let csv = [];

		if (this.state.data) {
			for (let i = 0; i < this.state.data.length; i++) {
				let data = {
					name: this.state.data[i].name,
					number: `=""${this.state.data[i].number}""`,
					memberId: this.state.data[i].memberId,
					rewardTimes: this.state.data[i].rewardedTimes,
					voucherReward: this.state.data[i].voucherReward,
					stampReward: this.state.data[i].stampReward,
					washerStamp: this.state.data[i].washerStamp,
					dryerStamp: this.state.data[i].dryerStamp,
					tokenReward: this.state.data[i].tokenReward,
					tokenGranted: this.state.data[i].tokenGranted,
				}
				csv.push(data);
			}
		}

		const csvData = {
			headers: [
				{ label: "User Name", key: "name" },
				{ label: "Phone Number", key: "number" },
				{ label: "Member ID", key: "memberId" },
				{ label: "Rewarded Times", key: "rewardTimes" },
				{ label: "Voucher Rewarded (times)", key: "voucherReward" },
				{ label: "Stamps Rewarded (times)", key: "stampReward" },
				{ label: "Washer Stamps Granted (stamp)", key: "washerStamp" },
				{ label: "Dryer Stamps Grant (stamp)", key: "dryerStamp" },
			],
			data: csv
		};

		let tableData = {
			columns: [
				{
					label: "Action",
					field: "action"
				},
				{
					label: "User Name",
					field: "name",
					sort: "asc"
				},
				{
					label: "Phone Number",
					field: "number",
					sort: "asc"
				},
				{
					label: "Member ID",
					field: "memberId",
					sort: "asc"
				},
				{
					label: "Rewarded Times",
					field: "rewardTimes",
					sort: "asc"
				},
				{
					label: "Voucher Rewarded (times)",
					field: "voucherReward",
					sort: "asc"
				},
				{
					label: "Stamps Rewarded (times)",
					field: "stampReward",
					sort: "asc"
				},
				{
					label: "Washer Stamps Granted (stamp)",
					field: "washerStamp",
					sort: "asc"
				},
				{
					label: "Dryer Stamps Grant (stamp)",
					field: "dryerStamp",
					sort: "asc"
				}
			],
			rows: []
		};

		if (this.props.admin?.token) {
			tableData.columns.push(
				{
					label: "e-Token Rewarded (times)",
					field: "tokenReward",
					sort: "asc"
				},
				{
					label: "Total e-Token Granted (token)",
					field: "tokenGranted",
					sort: "asc"
				}
			);

			csvData.headers = [
				{ label: "User Name", key: "name" },
				{ label: "Phone Number", key: "number" },
				{ label: "Member ID", key: "memberId" },
				{ label: "Rewarded Times", key: "rewardTimes" },
				{ label: "Voucher Rewarded (times)", key: "voucherReward" },
				{ label: "Stamps Rewarded (times)", key: "stampReward" },
				{ label: "Washer Stamps Granted (stamp)", key: "washerStamp" },
				{ label: "Dryer Stamps Grant (stamp)", key: "dryerStamp" },
				{ label: "e-Token Rewarded (times)", key: "tokenReward" },
				{ label: "Total e-Token Granted (token)", key: "tokenGranted" },
			]
		}

		if (this.state.data.length) {
			for (let i = 0; i < this.state.data.length; i++) {
				const dataObject = {
					action: (
						<button type="button" className="btn btn-primary" onClick={() => this.handleAction(this.state.data[i]._id)}>
							Reward
						</button>
					),
					name: this.state.data[i].name,
					number: this.state.data[i].number,
					memberId: this.state.data[i].memberId,
					rewardTimes: this.state.data[i].rewardedTimes,
					voucherReward: this.state.data[i].voucherReward,
					stampReward: this.state.data[i].stampReward,
					washerStamp: this.state.data[i].washerStamp,
					dryerStamp: this.state.data[i].dryerStamp,
					tokenReward: this.state.data[i].tokenReward,
					tokenGranted: this.state.data[i].tokenGranted
				};
				tableData.rows.push(dataObject);
			}
		}

		return (
			<div className="admin-page-container">
				<Sidebar toggled={this.state.toggled} setToggled={this.handleToggle} />
				<div className="admin-page">
					<Topbar handleToggle={this.handleToggle} />
					<div className="admin-content">
						<div className="card">
							<div className="card-header d-flex justify-content-between">
								<h5 className="card-title">Reward Giveaway</h5>
								<Link className="btn btn-primary" to="/admin/giveaway/history">
									Reward History
								</Link>
							</div>

							<div className="card-body text-center">
								{
									this.state.loading ? <Loading /> : (
										<div>
											<MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
											<div className="d-grid gap-2 d-md-flex justify-content-md-end">
												<CSVLink className="btn btn-primary" data={csvData.data} headers={csvData.headers} filename="reward.csv" target="_blank">
													Download Report
												</CSVLink>
											</div>
										</div>
									)
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		admin: state.admin.admin,
		token: state.admin.token
	};
};

export default connect(mapStateToProps, null)(Giveaway);
